import { render } from "./HeaderLogoSearch.vue?vue&type=template&id=1256ce11"
import script from "./HeaderLogoSearch.vue?vue&type=script&lang=js"
export * from "./HeaderLogoSearch.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__